import { is_empty } from "utils/validations";
import { api, dataProvider } from "data";
import constants from "constants/constants";

export const getSegmentList = async (showCount, targetValue, listingType) => {
  try {
    const data = await dataProvider.custom_request(
      api.segments.get_segment_list,
      "GET",
      {
        target: targetValue,
        page: "all",
        ...(listingType ? { listing_type: listingType } : {}),
      }
    );
    if (data.status === 200) {
      const tempArrayDefault = [];
      if (!is_empty(data.data.segments)) {
        for (let i = 0; i < data?.data?.segments?.length; i++) {
          let defaultSegments = {};

          const segments = data.data.segments[i] || {};

          if (showCount) {
            defaultSegments = {
              value: segments.uuid,
              is_high_converting: segments?.is_high_converting,
              id: segments.uuid,
              description: segments.description,
            };

            //Checks if the segment type is leads or customers
            if (targetValue === constants.segments_target_type.leads) {
              defaultSegments.label = data?.data?.segments[i]?.title;
              defaultSegments.segment_type =
                constants.segments_target_type.leads;
              defaultSegments.count = segments.stats ? segments.stats.leads : 0;
              defaultSegments.is_tag_embedded =
                data?.data?.segments[i]?.is_tag_embedded;
            } else {
              defaultSegments.label = data?.data?.segments[i]?.title;
              defaultSegments.segment_type =
                constants.segments_target_type.customers;
              defaultSegments.is_tag_embedded =
                data?.data?.segments[i]?.is_tag_embedded;

              defaultSegments.count = segments.stats
                ? segments.stats.customers
                : 0;
            }
          } else {
            defaultSegments = {
              label: data?.data?.segments[i]?.title,
              value: data?.data?.segments[i]?.uuid,
              is_high_converting: data?.data?.segments[i]?.is_high_converting,
              id: segments.uuid,
              is_tag_embedded: data?.data?.segments[i]?.is_tag_embedded,
            };
          }

          tempArrayDefault.push(defaultSegments);
        }
        return tempArrayDefault;
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log("Error in receiving Segment List", err);
  }
};

export const getSegementEmails = async ({ id, type, page = "all" }) => {
  try {
    const finalList = [];
    const finalURL =
      type === constants.segments_target_type.leads
        ? api.segments.get_segment_people_leads
        : api.segments.get_segment_people_customer;
    const data = await dataProvider.custom_request(finalURL, "GET", {
      segment_uid: id,
      page,
    });
    if (data.status === 200) {
      if (!is_empty(data.data.people)) {
        for (let i = 0; i < data?.data?.people?.length; i++) {
          const tempData = {
            name: data?.data?.people[i]?.display_name,
            email: data?.data?.people[i]?.email,
          };

          finalList.push(tempData);
        }

        const {
          data: { total, total_pages },
        } = data;

        return { finalList, total, totalPages: total_pages };
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log("Error in receiving Segment emails", err);
  }
};
